const toFa = str => {
    return str.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
};

export default toFa;
